import { Box, Modal, Fade } from '@mui/material';

type ImageModalInfoProps = {
  open: boolean;
  handleClose: () => void;
  image: string;
};
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  outline: 'none',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const ProductImageModal = ({ open, handleClose, image }: ImageModalInfoProps) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Fade in={open} timeout={500}>
        <Box sx={style}>
          {open && (
            <img
              src={image}
              alt='imprint-image-modal'
              data-testid='image-modal'
              style={{ maxHeight: '100%', maxWidth: '100%' }}
            />
          )}
        </Box>
      </Fade>
    </Modal>
  );
};

export default ProductImageModal;
